import React from "react";
import { BlurImage } from "./BlurImage";
import { nanoid } from "nanoid";
import { twMerge } from "tailwind-merge";
import Logo from "@images/Symbol_White.svg";
import Image from "next/image";

export const LoadingSmall = ({
  containerClassName,
  iconContainerClassName,
  imageClassName,
  text = "",
  ringClassName = "",
}: {
  containerClassName?: string;
  iconContainerClassName?: string;
  imageClassName?: string;
  text?: string | React.ReactNode;
  ringClassName?: string;
}) => {
  return (
    <div
      className={twMerge(
        "flex h-full w-full items-center justify-center",
        containerClassName
      )}
    >
      <div
        className={twMerge(
          "relative flex h-10 w-10 items-center justify-center rounded-full bg-green-500",
          iconContainerClassName
        )}
      >
        <BackgroundIllustration
          className={twMerge(
            "absolute z-20 h-12 w-12 stroke-gray-300",
            ringClassName
          )}
        />
        <Image
          alt="Logo"
          src={Logo}
          width="20"
          height="20"
          className="h-4 w-4 animate-pulse object-contain rounded-full"
        />
      </div>
      {text && text}
    </div>
  );
};

export function BackgroundIllustration(props: any) {
  let id = nanoid();

  return (
    <div {...props}>
      <svg
        viewBox="0 0 1026 1026"
        fill="none"
        aria-hidden="true"
        className="absolute inset-0 h-full w-full animate-spin-reverse-slower"
      >
        <path
          d="M913 513c0 220.914-179.086 400-400 400S113 733.914 113 513s179.086-400 400-400 400 179.086 400 400Z"
          stroke="#D4D4D4"
          strokeOpacity="1"
          strokeWidth={14}
        ></path>
        <path
          d="M913 513c0 220.914-179.086 400-400 400"
          stroke="url(#:R65m:-gradient-2)"
          strokeLinecap="round"
          strokeWidth={14}
        ></path>
        <defs>
          <linearGradient
            id=":R65m:-gradient-2"
            x1="913"
            y1="513"
            x2="913"
            y2="913"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#06b6d4"></stop>
            <stop offset="1" stopColor="#06b6d4" stopOpacity="0"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
